import React from "react";
import Box from "@mui/material/Box";

interface Props {
  text: string | undefined;
}

const Marquee: React.FC<Props> = ({text}) => {
  return (
    <Box className="marquee">
      <span>{text}</span>
    </Box>
  );
};
export default Marquee;
